<template>
	<li>
		<button type="button" class="uk-accordion-title">{{ displayNumber }}. {{ option.name }}</button>
		<div class="uk-accordion-content">
			<!-- Lights & Headboard -->
			<div class="lights-container">
				<div :key="'opt_' + option.id" class="uk-child-width-1-2@s uk-grid-collapse" uk-height-match=".cab-option-description" uk-grid role="radiogroup" :aria-label="option.name">
					<div>
						<button type="button" class="light-type" :class="{'selected' : !optionSelected(option)}" role="radio" :aria-checked="!optionSelected(option) ? 'true' : 'false'" :aria-label="option.disabled_title" @click.prevent="selectOption(option, false)">
							<p class="name">{{ option.disabled_title}}</p>
							<div class="light-wrapper">
								<img :src="imagePath(option.disabled_image)" alt="">
								<div class="cab-option-description" :class="{'left-align': isMattress}" v-html="option.disabled_description"></div>
							</div>
						</button>
					</div>
					<div>
						<button type="button" class="light-type" :class="{'selected' : optionSelected(option)}" role="radio" :aria-checked="optionSelected(option) ? 'true' : 'false'" :aria-label="option.enabled_title" @click.prevent="selectOption(option, true)">
							<p class="name">{{ option.enabled_title }} <span class="extra-price">{{ option.price | diffcurrency }}</span></p>
							<div class="light-wrapper">
								<img :src="imagePath(option.enabled_image)" alt="">
								<div class="cab-option-description" :class="{'left-align': isMattress}" v-html="option.description"></div>
							</div>
						</button>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "CabinetBedOption",

	props: {
		displayNumber: {
			type: Number,
			default: 2
		},
		option: {
			type: Object,
			default: () => {}
		},
		isMattress: {
			type: Boolean,
			default: false
		},
	},
	components: {},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {
		selectOption(option, setActive) {
			if(this.isMattress){
				setActive ? this.$store.commit('setSelectedMattress', option):this.$store.commit('setSelectedMattress', null);
				return;
			}
			let activeOptions = [];
			for (let i = 0; i < this.selectedOptions.length; ++i) {
				if (this.selectedOptions[i].id != option.id) { //re-store other options
					activeOptions.push(this.selectedOptions[i]);
				}
			}
			if (setActive) { // add if set to do so
				activeOptions.push(option);
			}
			this.$store.commit('setSelectedAdditionalOptions', activeOptions);
		},
		optionSelected(option) {
			if(this.isMattress){
				return this.selectedMattress && this.selectedMattress.id == option.id;
			}
			for (let i = 0; i < this.selectedOptions.length; ++i) {
				if (this.selectedOptions[i].id == option.id) {
					return true;
				}
			}

			return false;
		},
		imagePath(image) {
			if (image) {
				return image.webPath + "/190";
			}

			return "/wp-content/themes/wallbeds/img/light-placeholder.jpg";
		},
	},
	computed: {
		...mapState({
			selectedOptions: state => state.selected_options,
			selectedMattress: state => state.selected_mattress,
		})
	},
	watch: {}
}
</script>